export default "__VITE_ASSET__CW75X55B__"